import axios from 'axios';

class whiteListService {
    constructor() {
        this.state = {
            apiUrl: process.env.REACT_APP_API_URL,
        };
    }

    getAllWhitelistByCustomerId(customerId) {
        return axios
            .get(this.state.apiUrl + 'admin/whitelist?customerId=' + customerId, { silent: true })
            .then((res) => {
                return res.data.data;
            })
            .catch((err) => {
                return err;
            });
    }

    deleteWhitelist(whitelistId) {
        return axios
            .delete(this.state.apiUrl + 'admin/deleteWhiteList/' + whitelistId)
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                return err;
            });
    }

    saveOrUpdateWhitelist(params) {
        if (params.id) {
            return axios
                .put(this.state.apiUrl + 'admin/updateWhitelist', JSON.stringify(params))
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return err;
                });
        } else {
            return axios
                .post(this.state.apiUrl + 'admin/saveWhitelist', JSON.stringify(params))
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return err;
                });
        }
    }
}

export default whiteListService;
